import { ButtonTooltip } from 'src/app/domain/shared/component/buttons/button.component';
import { FinancialStatementAccount } from '../../models/common/FinancialStatementAccount';
import { FinancialStatementItem } from '../../models/common/FinancialStatementItem';
import { FinancialStatementPart } from '../../models/common/FinancialStatementPart';
import { FsSums } from '../common/FsSums';

export interface ObjectForNameModal {
  isNew: boolean;
  name: string;
  isAssetsAndLiabilities: boolean;
  isPL: boolean;
  partToAddTo: FinancialStatementPart;
  existingNames: string[];
}

export interface ObjectForAccountsModal {
  unallocated: FinancialStatementAccount[];
  allocated: FinancialStatementAccount[];
  key: string;
  itemName: string;
}

export interface ObjectForItemDeleteModal {
  itemToBeRemoved: FinancialStatementItem;
  parentPart: FinancialStatementPart;
  description: string;
}

export class UnallocatedFSData {
  accounts: FinancialStatementAccount[];
  sums: FsSums;
  unallocatedTooltip: ButtonTooltip;
  isUnallocatedCheck: boolean; // whether there is any sum in unallocated accounts in BS or PL

  constructor(
    accounts?: FinancialStatementAccount[],
    sums?: FsSums,
    unallocatedTooltip?: ButtonTooltip,
    isUnallocatedCheck?: boolean) {
    this.accounts = accounts;
    this.sums = sums;
    this.unallocatedTooltip = unallocatedTooltip;
    this.isUnallocatedCheck = isUnallocatedCheck;
  }

  hasSums(): boolean {
    if (!this.sums) {
      return false;
    }
    const negligibleValue = 0.0001;
    for (const sum in this.sums) {
      if (this.sums[sum] > negligibleValue || this.sums[sum] < negligibleValue / -1) {
        return true;
      }
    }
    return false;
  }
}

export class ShowBS {
  // show/hide modals
  modalForAddItem = false;
  modalForAddAccounts = false;
  thinkTwiceModalItemDelete = false;

  // show/hide vars for parts
  parts = {
    Assets: true,
    Liabilities: true,
    'Partners capital': true,
    Profits: true,
    Losses: true,
  };

  accounts = false;
  unallocatedAccounts = false;
  emptyState = true;
}

